<template>
    <b-card no-body>
        <div class="card-header pb-1">
            <b-card-title>
                {{ $t('Component(Text):settings') }}
            </b-card-title>
        </div>
        <div class="p-2">
            <validation-observer ref="settings">
                <div class="mb-2">
                    <h5 class="mb-1">
                        General
                    </h5>
                    <b-form-checkbox
                        id="testSubscriber"
                        v-model="isTestSubscriber"
                        @change="emit"
                        :placeholder="$t('Component(Placeholder):comment')"
                    >
                        Is test subscriber
                    </b-form-checkbox>
                </div>

                <div>
                    <h5 class="mb-1">
                        AI
                    </h5>
                    <b-form-checkbox
                        id="processProductCardDocuments"
                        v-model="processProductCardDocuments"
                        @change="emit"
                    >
                        Process product card documents
                    </b-form-checkbox>
                    <b-form-checkbox
                        id="processSupplierRequestReplyDocuments"
                        v-model="processSupplierRequestReplyDocuments"
                        @change="emit"
                    >
                        Process supplier request reply documents
                    </b-form-checkbox>
                    <b-form-checkbox
                        id="processSupplierEmailDocuments"
                        v-model="processSupplierEmailDocuments"
                        @change="emit"
                    >
                        Process supplier email documents
                    </b-form-checkbox>
                </div>
            </validation-observer>
        </div>
    </b-card>
</template>

<script>
import backendResponse from "@core/mixins/ui/backend-response";
import AddEditOrganization from "@/views/administration/organization/AddEditOrganization";
import Actions from "@/views/administration/subscriber/components/Actions";
import {required} from '@validations'
import {BOverlay, BCard, BCardTitle, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
    BFormDatepicker} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    mixins: [backendResponse],
    components: {
        BOverlay, BCard, BCardTitle, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
        AddEditOrganization, Actions, ValidationProvider, ValidationObserver, BFormDatepicker,
    },
    props: {
        settings: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isTestSubscriber: false,
            processProductCardDocuments: false,
            processSupplierRequestReplyDocuments: false,
            processSupplierEmailDocuments: false,
            required,
        };
    },
    methods: {
        emit() {
            this.$emit('input', {
                isTestSubscriber: this.isTestSubscriber,
                ai: {
                    processProductCardDocuments: this.processProductCardDocuments,
                    processSupplierRequestReplyDocuments: this.processSupplierRequestReplyDocuments,
                    processSupplierEmailDocuments: this.processSupplierEmailDocuments,
                },
            });
        },
        validate() {
            return this.$refs.settings.validate();
        }
    },
    watch: {
        settings: {
            immediate: true,
            handler(v) {
                const settings = v && typeof v === 'object' ? v : {};
                const ai = settings.ai && typeof settings.ai === 'object' ? settings.ai : {};

                this.isTestSubscriber = settings.isTestSubscriber === true;
                this.processProductCardDocuments = ai.processProductCardDocuments === true;
                this.processSupplierRequestReplyDocuments = ai.processSupplierRequestReplyDocuments === true;
                this.processSupplierEmailDocuments = ai.processSupplierEmailDocuments === true;
            }
        },
    }
}
</script>

<style scoped>

</style>
